import { render, staticRenderFns } from "./treaty.vue?vue&type=template&id=7b981880&scoped=true"
import script from "./treaty.vue?vue&type=script&lang=js"
export * from "./treaty.vue?vue&type=script&lang=js"
import style0 from "./treaty.vue?vue&type=style&index=0&id=7b981880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b981880",
  null
  
)

export default component.exports